"use client";

import React from "react";
import { Toaster as Sonner } from "sonner";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { ToasterProps } from "./types";

function Toaster({ className, ...props }: ToasterProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Sonner
      className={cn("toaster group", className, classes)}
      toastOptions={{
        classNames: {
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground hover:bg-primary/80 shadow-lg",
          cancelButton: "group-[.toast]:bg-gold group-[.toast]:text-primary",
          description: "group-[.toast]:text-white",
          toast:
            "group toast group-[.toaster]:bg-foreground group-[.toaster]:text-white group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        },
      }}
      {...native}
    />
  );
}

Toaster.displayName = "Toaster";

export default Toaster;
